import checkout from "./form4";

const {
  formField4: {
    countryName,
    carrierName,
    year,
    supplementaryForThe,
    firstTime,
    vehicleName,
    taxPayerInstead,
    taxPayerInsteadId
  },
} = checkout;

const initialValues4 = {
  [countryName.name]: "",
  [carrierName.name]: "",
  [year.name]: "",
  [supplementaryForThe.name]: "",
  [firstTime.name]: false,
  [vehicleName.name]: "",
  [taxPayerInstead.name]: "",
  [taxPayerInsteadId.name]: "",
};

export default initialValues4;
